import extend from '@/utils/vuex-extend';
import { base } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import {goodsEditInfo} from "@/api/gm/goods";

export default extend(base, {
	namespaced: true,
	state: {
		goodsInfo: {},
		goodsId: ''
	},
	actions: {
		async getGoodsEditInfo({ dispatch, commit, state }, payload) {
			const { goodsId } = payload;
			console.log('test', payload)

			await wait(dispatch, 'pcm.auto-purchase.index', async function() {
				const response = await goodsEditInfo({goodsId})
				if (response.code === 200) {
					commit('save', {
						goodsInfo: response.data
					})
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/auto-purchase/index.js